import { SvgIcon, SvgIconProps } from "@mui/material"

const appearanceIconSvg = (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="8 8 32 32" fill="none">
            <circle cx="23.0953" cy="23.0953" r="13.5953" stroke="currentColor"/>
            <path d="M23.0953 32.7271C17.7758 32.7271 13.4635 28.4148 13.4635 23.0953C13.4635 17.7758 17.7758 13.4635 23.0953 13.4635" stroke="currentColor" strokeWidth="9"/>
            <path d="M23.5953 18.2129C26.0705 18.4633 28.0026 20.5545 28.0026 23.0957C28.0024 25.6367 26.0703 27.7261 23.5953 27.9766V18.2129Z" fill="currentColor" stroke="currentColor"/>
        </svg>
    )


const AppearanceIcon: React.FC<SvgIconProps> = (props) => (
    <SvgIcon {...props}>
        {appearanceIconSvg}
    </SvgIcon>
)

export default AppearanceIcon
